import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from '@mui/material'
import './index.css'
import theme from 'providers/theme'
import Snackbar from 'components/Snackbar'
import LoginPage from 'pages/LoginPage'
import AuthGoogle from 'pages/AuthGoogle'
import AuthLinkedin from 'pages/AuthLinkedin'
import AuthSlack from 'pages/AuthSlack'
import Logout from 'pages/Logout'
import VerifyEmail from 'pages/VerifyEmail'
import NotFound from 'pages/NotFound'
import SignUpBuyer from 'pages/SignUpBuyer'
import SignUpSeller from 'pages/SignUpSeller'
import SignUpReviewer from 'pages/SignUpReviewer'
import Invitation from 'pages/Invitation'
import ConnectPasskey from 'pages/ConnectPasskey'
import ResetPassword from 'pages/ResetPassword'
import RequestPasswordReset from 'pages/RequestPasswordReset'
import SignUpMaven from 'pages/SignUpMaven'
import SignUpProductPage from 'pages/SignUpProductPage'
import TagManager from 'react-gtm-module'
import { API_URL, GOOGLE_TAG_MANAGER_ID, env } from 'helpers/config'
import * as Sentry from '@sentry/react'
import SignUpTribe from 'pages/SignUpTribe'
import SignUpBuyerFinancing from 'pages/SignUpBuyerFinancing'

if (env === 'production') {
  Sentry.init({
    dsn: 'https://b1757ac3bdfe17de672697e2e17db28e@o1413067.ingest.us.sentry.io/4507052739592192',
    environment: env,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions

    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [API_URL],

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

TagManager.initialize({ gtmId: GOOGLE_TAG_MANAGER_ID })

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to={`/login`} replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpBuyer />} />
          <Route path="/signup-financing" element={<SignUpBuyerFinancing />} />
          <Route path="/signup-seller" element={<SignUpSeller />} />
          <Route path="/signup-tribe" element={<SignUpTribe />} />
          <Route path="/signup-maven" element={<SignUpMaven />} />
          <Route path="/signup-product/:productId" element={<SignUpProductPage />} />
          <Route path="/signup-reviewer/:productId" element={<SignUpReviewer />} />
          <Route path="/google" element={<AuthGoogle />} />
          <Route path="/linkedin" element={<AuthLinkedin />} />
          <Route path="/slack" element={<AuthSlack />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/invitation/:invitationToken" element={<Invitation />} />
          <Route path="/passkey/connect" element={<ConnectPasskey />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/request-password-reset" element={<RequestPasswordReset />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>

      <Snackbar />
    </ThemeProvider>
  </React.StrictMode>
)
